import { js_utils } from "../frfr-js-utils";
import { _zzyourmap_config } from "./zz-yourmap-config";
import { _zzyourmap_img_url_full_from_parts } from "./zz-yourmap-image-utils";
import { _zzyourmap_extract_smestaj_map_marker_item_props } from "./zz-yourmap-map-utils";
import { _zzyourmap_extract_destination_main_img_url } from "./zz-yourmap-data-prepare-2-entities";
import { _zzyourmap_LAYER_TITLE_ALWAYSSHOW } from "./zz-yourmap-data-keys-and-values-lib";


// -----


// TODO
export const _zzyourmap_comvert_slug_to_id_smart = (slug, slug_to_id_lookup_obj) => {
  if (js_utils.is_object(slug_to_id_lookup_obj) && slug in slug_to_id_lookup_obj) {
    return slug_to_id_lookup_obj[slug];
  } else {
    return slug;
  }
};


//
export const _zzyourmap_extract_current_destination_entity = (destination_entities, route_destination_id) => {
  let current_destination_entity = {};
  if (Array.isArray(destination_entities)) {
    // console.log('destination_entities', destination_entities);
    destination_entities.forEach((item, index) => {
      if (item.vr_tablename === 'ym_table_destination') {
        if (item.destinacija_tip === "DESTINATION") {
          // if (item.of_id > 0 && item.of_id === route_destination_id) { // BINGO
          if (item.of_id > 0 && (item.of_id === route_destination_id || item.destinacija_slug === route_destination_id)) { // BINGO
            current_destination_entity = { ...item };
          }
        } else if (item.destinacija_tip === "SUBDESTINATION") {
          // subdestination_entities.push({ ...item });
        }
      }
    });
  }
  console.log('ENRICHED current_destination_entity', current_destination_entity);
  return current_destination_entity;
};


//
export const _zzyourmap_extract_current_ymthing_entity = (ymthing_entities, ymostalo_v1_entities, route_smestaj_id, thing_type) => {
  let current_thing_entity = {};
  if (Array.isArray(ymthing_entities)) {
    // console.log('ymthing_entities', ymthing_entities);
    ymthing_entities.forEach((item, index) => {
      let _valid_thing = false;
      if (item.vr_tablename === 'ym_table_smestaj') {
        _valid_thing = true;
      } else if (item.vr_tablename === 'ym_table_restoran') {
        _valid_thing = true;
      } else if (item.vr_tablename === 'ym_table_servis') {
        _valid_thing = true;
      } else if (item.vr_tablename === 'ym_table_prodavnica') {
        _valid_thing = true;
      } else if (item.vr_tablename === 'ym_table_aktivnost') {
        _valid_thing = true;
      } else if (item.vr_tablename === 'ym_table_znamenitost') {
        _valid_thing = true;
      } else if (item.vr_tablename === 'ym_table_ostalo_v2') { // novo ostalo
        _valid_thing = true;
      }
      if (_valid_thing === true) {
        if (item.of_id > 0 && item.of_id === route_smestaj_id) { // BINGO
          current_thing_entity = { ...item };
        }
      }
    });
  }
  if (Array.isArray(ymostalo_v1_entities)) {
    // console.log('ymostalo_v1_entities', ymostalo_v1_entities);
    ymostalo_v1_entities.forEach((item, index) => {
      let _valid_thing = false;
      if (item.vr_tablename === 'ym_table_ostalo_v1') { // blog
        _valid_thing = true;
      }
      if (_valid_thing === true) {
        if (item.of_id > 0 && item.of_id === route_smestaj_id) { // BINGO
          current_thing_entity = { ...item };
        }
      }
    });
  }
  console.log('ENRICHED current_thing_entity', current_thing_entity);
  return current_thing_entity;
};


// NEW
export const _zzyourmap_filter_ymthing_entites_by_parent_destination_and_tab_v3 = (entities, route_destination_id, route_destination_tab) => {
  console.log('_zzyourmap_filter_ymthing_entites_by_parent_destination_and_tab_v3', 'route_destination_id', route_destination_id, 'route_destination_tab', route_destination_tab);
  console.log('entities', entities);
  const entities_of_destination_and_tab = [];
  entities.forEach(item => {
    // console.log('item', item);
    if (item._is_public === true) { // only public entities will be considered
      ////
      if ((typeof route_destination_id === 'string' && item?._routing_parent_real_destination_slug === route_destination_id) || (route_destination_id > 0 && item._routing_parent_real_destination_id === route_destination_id)) {
        // matched route_destination_id or slug
        if (item?._routing_tab === route_destination_tab) {
          // also matched tab
          entities_of_destination_and_tab.push(item);
        }
      }
    }
  }); // end of forEach
  console.log('entities_of_destination_and_tab', entities_of_destination_and_tab);
  return entities_of_destination_and_tab;
};


//
export const _zzyourmap_extract_marker_entities_by_route_subdestination_id = (entities1, entities2, route_destination_id, route_subdestination_id) => {
  console.log('_zzyourmap_extract_marker_entities_by_route_subdestination_id', 'route_destination_id', route_destination_id, 'route_subdestination_id', route_subdestination_id);
  let map_props_markers_arr = [];
  let marker_layer_titles_used = [];
  //
  let is_subdestionation = false;
  let marker_parent_destinacija_id = route_destination_id;
  if (route_subdestination_id > 0) {
    is_subdestionation = true;
    marker_parent_destinacija_id = route_subdestination_id;
  }
  console.log('is_subdestionation', is_subdestionation);
  let markerable_entities = entities1;
  if (Array.isArray(entities2)) {
    markerable_entities = [...entities1, ...entities2];
  }
  console.log('* markerable entities (ymthing + ostalo)', markerable_entities);
  //
  markerable_entities.forEach(item => {
    // console.log('item', item);
    // console.log(item?.parent_destinacija_id);
    // console.log(Number.parseFloat(item?.parent_destinacija_id));
    if (item?.smestaj_marker_enabled === true) {
      let do_add = false;
      if ((typeof route_destination_id === 'string' && item?._routing_parent_real_destination_slug === route_destination_id) || (route_destination_id > 0 && item._routing_parent_real_destination_id === route_destination_id)) {
        // matched route_destination_id or slug
        if (item?._routing_parent_subdestination_id_for_map === route_subdestination_id) {
          // also matched route_subdestination_id
          // BINGO
          do_add = true;
        }
      }
      //
      if (do_add === true) {
        const marker_single = _zzyourmap_extract_smestaj_map_marker_item_props(item);
        if (marker_single) {
          map_props_markers_arr.push(marker_single);
          if (typeof marker_single.layer_title === 'string') {
            if (marker_layer_titles_used.includes(marker_single.layer_title)) {
              // already included
            } else {
              if (marker_single.layer_title !== _zzyourmap_LAYER_TITLE_ALWAYSSHOW) {
                marker_layer_titles_used.push(marker_single.layer_title);
              }
            }
          }
        }
      }
    }
    //
  }); // end of forEach
  console.log('map_props_markers_arr', map_props_markers_arr);
  console.log('marker_layer_titles_used', marker_layer_titles_used);
  return { map_props_markers_arr, marker_layer_titles_used };
};

